module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"moment","commonjs2":"moment","amd":"moment"}
// module id = 13
// module chunks = 0